const rawSubdomains = process.env.REACT_APP_KIOSK_SUBDOMAIN?.trim();
const parsedSubdomains = (rawSubdomains || 'orbiter')
    .toLowerCase()
    .split(',')
    .map((subdomain) => subdomain.trim())
    .filter(Boolean);

const KIOSK_SUBDOMAINS = parsedSubdomains.length > 0 ? parsedSubdomains : ['orbiter'];

export const isKioskHostname = (hostname: string) => {
    const h = hostname.toLowerCase();

    return KIOSK_SUBDOMAINS.some((subdomain) => h.startsWith(`${subdomain}.`));
};